import {
  Decimal,
  LiquityStoreState,
  StabilityDeposit,
  StabilityDepositChange,
  UserTrove
} from "@liquity/lib-base";

import { COIN } from "../../../strings";
import { Amount } from "../../ActionDescription";
import { ErrorDescription } from "../../ErrorDescription";
import { StabilityActionDescription } from "../StabilityActionDescription";
import { CollateralLexicon } from "src/lexicon"

export const selectForStabilityDepositChangeValidation = (collateralKey: string | undefined) => {
  return ({
    slsdBalance,
    collateralStates,
    collateralDerivedStates
  }: LiquityStoreState) => {
    if (!collateralKey) {
      return {
        trove: UserTrove.createEmpty(),
        slsdBalance: Decimal.ZERO,
        stabilityDeposit: new StabilityDeposit(Decimal.ZERO, Decimal.ZERO, Decimal.ZERO, Decimal.ZERO),
        price: Decimal.ZERO,
        haveUndercollateralizedTroves: false
      }
    }

    const { stabilityDeposit, price } = collateralStates[collateralKey];
    const { trove, haveUndercollateralizedTroves } = collateralDerivedStates[collateralKey];
    return {
      trove,
      slsdBalance,
      stabilityDeposit,
      price,
      haveUndercollateralizedTroves
    }
  };
}

// type StabilityDepositChangeValidationContext = ReturnType<
//   typeof selectForStabilityDepositChangeValidation
// >;
type StabilityDepositChangeValidationContext = {
  trove: UserTrove
  slsdBalance: Decimal
  stabilityDeposit: StabilityDeposit
  price: Decimal
  haveUndercollateralizedTroves: boolean
}

export const validateStabilityDepositChange = (
  originalDeposit: StabilityDeposit,
  editedSLSD: Decimal,
  {
    slsdBalance,
    haveUndercollateralizedTroves
  }: StabilityDepositChangeValidationContext,
  lexicon: CollateralLexicon | undefined
): [
  validChange: StabilityDepositChange<Decimal> | undefined,
  description: JSX.Element | undefined
] => {
  const change = originalDeposit.whatChanged(editedSLSD);

  if (!change) {
    return [undefined, undefined];
  }

  if (change.depositSLSD?.gt(slsdBalance)) {
    return [
      undefined,
      <ErrorDescription>
        The amount you're trying to deposit exceeds your balance by{" "}
        <Amount>
          {change.depositSLSD.sub(slsdBalance).prettify()} {COIN}
        </Amount>
        .
      </ErrorDescription>
    ];
  }

  if (change.withdrawSLSD && haveUndercollateralizedTroves) {
    return [
      undefined,
      <ErrorDescription>
        You're not allowed to withdraw SLSD from your Stability Deposit when there are
        undercollateralized Troves. Please liquidate those Troves or try again later.
      </ErrorDescription>
    ];
  }

  return [change, <StabilityActionDescription originalDeposit={originalDeposit} change={change} lexicon={lexicon}/>];
};
